export default __webpack_public_path__ + "static/media/12.8bc216d4.jpeg";